<script>
    import InputField from "../../../ui_elements/InputField.svelte";
    import GewichtungSelect from "./GewichtungSelect.svelte";
    import SchwerpunktSelect from "./SchwerpunktSelect.svelte";

    export let selected;
    export let schwerpunkte;
    export let label;
</script>

{#each selected || [] as option}
<div class="w-full flex items-start mb-4">
    <InputField bind:value={option.questionText} id={option.questionText} {label} disabled=true />
    <SchwerpunktSelect bind:value={option.schwerpunkt} {schwerpunkte}/>
    <GewichtungSelect bind:value={option.weight} />
</div>
{/each}
